// AI Generated Test
import { Component, Input } from '@angular/core';

@Component({
    selector: 'seo-information-too-long-meta-description',
    standalone: false,
    template: `
        @let seoContentCount = count(seo?.content);
        @let seoContentCharacterCount = countCharacters(seo?.content);
        <h5>
            <ng-container *ngIf="seoContentCount === 1">
                <span translate>There is 1 META description on this page</span>
            </ng-container>
            <ng-container *ngIf="seoContentCount > 1">
                <span translate [translate-args]="{seoContentCount}">There are [[seoContentCount]] META descriptions on this page</span>
            </ng-container>
            ( {{ seoContentCharacterCount }}
            <ng-container *ngIf="seoContentCharacterCount === 1">
                <span translate>Character</span>
            </ng-container>
            <ng-container *ngIf="seoContentCharacterCount !== 1">
                <span translate>Characters</span>
            </ng-container>)
        </h5>

        <ul class="list-unstyled">
            <li *ngFor="let description of seo?.content; trackBy: trackByIndex">{{ description }}</li>
        </ul>
    `,
})
export class SeoInformationTooLongMetaDescriptionComponent {
    @Input() seo: any;

    count (content: any): number {
        if (Array.isArray(content)) {
            return content.length;
        } else if (content === null || content === undefined) {
            return 0;
        }

        return 1;
    }

    countCharacters (content: any): number {
        if (Array.isArray(content)) {
            return content.reduce((a: number, b: string) => {
                return a + b.length;
            }, 0);
        }
        return 0;
    }

    trackByIndex (index: number): number {
        return index;
    }
}
